AppTabs.createTab( {
name: 'client-test-list-management',
icon: 'vial',
text: 'Client Test List Management',
create: function() {
    'use strict'

    return new TabControllerVue( {
        el: '#vue-client-test-list-management',
        store, // vue store
        lockUpdates: true,
        methods: {
            resetData() {
                this.client         = null;
                this.testLists      = [];

                this.clientTestList = null;
                this.testListTests  = [];
            },

            /*******
             * AJAX
             */
            addTestList: function() {
                const _this = this;
                window.InputModalManager.show({
                    title 		: 'Add New Client Test List',
                    inputText   : '',
                    buttonText	: 'Add Client Test List',
                    callback 	: function( name ) {
                        if ( name ) {
                            window.ajaxCall({
                                data : {
                                    action: 'add_client_test_list',
                                    client_id: _this.clientId,
                                    name: name,
                                },
                                successMessage: 'Successfully Added Client Test List',
                                onSuccess : function( response ) {
                                    _this.testLists = response.data.testLists;
                                    const newTestList = _this.testLists && _this.testLists.find( testList => testList.id == response.data.id ) || null;
                                    _this.clientTestList = newTestList;
                                }
                            });
                        } else {
                            window.WarningModalManager.show( { message: 'A name is required when adding a Client Test List!' } );
                        }
                    },
                });
            },

            renameTestList: function() {
                const _this = this;
                const oldName = this.clientTestList.text;
                window.InputModalManager.show({
                    title 		: 'Rename Client Test List',
                    inputText   : this.testListName,
                    buttonText	: 'Rename Client Test List',
                    callback 	: function( name ) {
                        if ( name ) {
                            window.ajaxCall({
                                data : {
                                    action: 'rename_client_test_list',
                                    client_test_list_id: _this.testListId,
                                    client_id: _this.clientId,
                                    name: name,
                                },
                                successMessage: 'Successfully Renamed Client Test List',
                                onSuccess: function( response ) {
                                    _this.testLists = response.data.testLists;
                                    const newTestList = _this.testLists
                                        && _this.testLists.find( testList => testList.id == response.data.id ) || null;
                                    _this.clientTestList = newTestList;
                                },
                                onError: function () {
                                    _this.clientTestList.text = oldName;
                                }
                            });
                        } else {
                            window.WarningModalManager.show( { message: 'A name is required when renaming a Client Test List!' } );
                        }
                    },
                });
            },

            deleteTestList: function() {
                const _this = this;
                const id = this.testListId
                this.lockUpdates( 'deleteTestLists' );
                window.ConfirmationModalManager.show({
                    title 		: 'Confirm Client Test List Deletion',
                    message		: 'Are you sure you want to permanently delete the Client Test List "'
                                    + this.testListName
                                    + '"?',
                    buttonText	: 'Delete',
                    callback 	: function() {
                        window.ajaxCall({
                            data : {
                                action: 'delete_client_test_list',
                                client_test_list_id: _this.testListId,
                                client_id: _this.clientId,
                            },
                            successMessage: 'Successfully Deleted Client Test List',
                            onSuccess( response ) {
                                _this.unlockUpdates( 'deleteTestLists' );
                                _this.testLists = response.data.testLists;
                                _this.clientTestList = null;
                            },
                            onError() {
                                // set selected test list
                                _this.unlockUpdates( 'deleteTestLists' );
                                const newTestList = _this.testLists && _this.testLists.find( list => list.id == id ) || null;
                                _this.clientTestList = newTestList;
                            },
                        });
                    },
                });
            },

            loadTestLists: function() {
                if ( ! this.clientId ) { return; }
                if ( this.getUpdateLockLevel() ) { return; }
                this.lockUpdates( 'loadTestLists' );
                const _this = this;
                this.clientTestList = null;
                window.ajaxCall({
                    data : {
                        action: 'get_client_test_lists',
                        client_id: this.clientId,
                    },
                    successMessage: 'Successfully Loaded Client Test Lists',
                    onSuccess : function( response ) {
                        _this.testLists = response.data;
                        _this.unlockUpdatesLater( 'loadTestLists' );
                    },
                });
            },

            loadTestListTestsResponse (data) {
                this.testListTests = data;
                this.unlockUpdatesLater( 'loadTestListTestsResponse' );
            },

            loadTestListTests: function() {
                if ( this.lockLevel ) { return; }
                if ( this.testListId === null ) {
                    this.testListTests = [];
                    return;
                }
                this.lockUpdates( 'loadTestListTests' );
                const _this = this;
                window.ajaxCall({
                    data : {
                        action: 'get_client_test_list_tests_by_id',
                        client_test_list_id: this.testListId
                    },
                    successMessage: 'Successfully Loaded Client Test List Tests',
                    onSuccess : function(response) {
                        let data = response.data;
                        _this.loadTestListTestsResponse(data);
                    },
                    onError : _this.unlockUpdates,
                });
            },
            addTestToClientList: function(test_ids) {
                if ( ! this.testListId ) { return; }
                if ( this.getUpdateLockLevel() ) { return; }
                this.lockUpdates( 'updateTestListTests' );
                const _this = this;
                let testIdArray = test_ids.split(",");
                window.ajaxCall({
                    data : {
                        action: 'add_test_to_client_list',
                        client_test_list_id: this.testListId,
                        test_ids: testIdArray,
                    },
                    successMessage: 'Successfully Updated Client Test List',
                    onSuccess : function(response) {
                        let data = response.data;
                        _this.loadTestListTestsResponse(data);
                    },
                    onError : _this.unlockUpdates,
                });
            },
            removeTestFromClientList: function(test_ids) {
                if ( ! this.testListId ) { return; }
                if ( this.getUpdateLockLevel() ) { return; }
                this.lockUpdates( 'updateTestListTests' );
                const _this = this;
                window.ajaxCall({
                    data : {
                        action: 'remove_test_from_client_list',
                        client_test_list_id: this.testListId,
                        test_ids: test_ids,
                    },
                    successMessage: 'Successfully Updated Client Test List',
                    onSuccess : function(response) {
                        let data = response.data;
                        _this.loadTestListTestsResponse(data);
                    },
                    onError : _this.unlockUpdates,
                });
            },
            updateTestListTests: function(selectedTestIds) {
                if ( ! this.testListId ) { return; }
                if ( this.getUpdateLockLevel() ) { return; }
                this.lockUpdates( 'updateTestListTests' );
                const _this = this;
                window.ajaxCall({
                    data : {
                        action: 'update_client_test_list',
                        client_test_list_id: this.testListId,
                        test_ids: selectedTestIds,
                    },
                    successMessage: 'Successfully Updated Client Test List',
                    onSuccess : function(response) {
                        let data = response.data;
                        _this.loadTestListTestsResponse(data);
                    },
                    onError : _this.unlockUpdates,
                });
            },
        },

        computed: {
			// Load locally loaded client list
            clients: _ => store.state.clientList,

            clientName: function() {
                return this.client !== null ? this.client.text : null;
            },

            clientId: function() {
                return this.client !== null ? this.client.id : null;
            },

            testListName: function() {
                return this.clientTestList !== null ? this.clientTestList.text : null;
            },

            testListId: function() {
                return this.clientTestList !== null ? this.clientTestList.id : null;
            },

            testList: function() {
                return store.state.testList;
            },
        },
        watch: {
            client: function() {
                this.loadTestLists();
            },
            clientTestList: function() {
                this.loadTestListTests();
            },
            testListTests: function() {
                this.updateTestListTests( this.testListTests.map( test => test.id ) );
            },
        }
    } );

}

} );
